export default __webpack_public_path__ + "static/media/bw_photos_tuscany-1.6371a994.jpg";